import { render, staticRenderFns } from "./MajorPage.vue?vue&type=template&id=b9c06e5c"
import script from "./MajorPage.vue?vue&type=script&lang=js"
export * from "./MajorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports